export default __webpack_public_path__ + "static/kevin-8527b41cffd5b59cf52cc977995dc71c.jpg";